<template>
  <div class="bg" v-loading="loading">
    <Header />
    <div style="clear: both"></div>
    <div class="loginwrap">
      <h2>欢迎加入FunCode</h2>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="昵称" prop="username">
          <el-input type="text" v-model="ruleForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" class="input-with-select">
            <template #prepend> +86 </template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email" class="input-with-select">
            <template #prepend> @ </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入验证码" v-model="ruleForm.randCode" class="input-with-select">
            <template #append>
              <el-button @click="getCodeWithEmail()">{{ codemsg }}</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked">
            <router-link :to="{
              name: 'service',
            }">《FunCode网站服务条款》</router-link>|<router-link :to="{
                          name: 'privacy',
                        }">《法律声明和隐私权政策》</router-link>
          </el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style scoped>
.bg {
  background-color: #f5f5f6;
  padding-bottom: 80px;
}

h2 {
  text-align: center;
  color: #373d41;
  font-weight: normal;
}

.loginwrap {
  background-color: white;
  width: 480px;
  margin: 0 auto;
  border: 1px solid #cccccc;
  padding: 20px 40px 0px 0px;
  margin-top: 80px;
}
</style>

<script>
import Header from "./header";

export default {
  name: "Reg",
  components: {
    Header,
  },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入昵称"));
      } else {
        if (this.ruleForm.username !== "") {
          this.$refs.ruleForm.validateField("checkName");
        }
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        if (this.ruleForm.phone !== "") {
          this.$refs.ruleForm.validateField("checkPhone");
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    var validateEmail = (rule, value, callback) => {
      let emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (value === "") {
        callback(new Error("请输入邮箱"));
      } else if (emailRegex.test(value) == false) {
        callback(new Error("邮箱地址格式不正确!"));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        password: "",
        checkPass: "",
        username: "",
        randCode: "",
        phone: "",
        email: ""
      },
      loading: false,
      checked: true,
      smsSending: false,
      codemsg: "获取验证码",
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        username: [{ validator: validateName, trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      if(!this.checked){
        this.$alert("请阅读并同意协议", "", {
        confirmButtonText: "确定",
      });
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //数据正确
          //验证code是否正确
          this.loading = true;
          let code = this.ruleForm.randCode;
          let verimodel = { code: code, email: this.ruleForm.email };
          //this.$http.post("/api/VerifyCode", verimodel).then((res) => {
          this.$http.post("/api/email", verimodel).then((res) => {
            if (res.data.code == 200) {
              //注册
              var objData = {};
              for (let key in this.ruleForm) {
                objData[key] = this.ruleForm[key];
                //formData.append(key, this.ruleForm[key]);
              }
              //var jsonStr = JSON.stringify(objData);
              //JSON.parse(jsonStr)
              this.$http
                .post("/api/reg", objData)
                .then((r) => {
                  this.loading = false;
                  if (r.data.code != 200) {
                    //注册失败
                    this.$message.error(r.data.msg);
                  } else {
                    this.$router.push({ name: "regsucc" });
                  }
                }) //接口调用成功返回的数据
                .catch((err) => {
                  console.log(err);
                  this.loading = false;
                }); //接口调用失败返回的数据
            } else {
              this.loading = false;
              this.$message.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      //注册
      this.$router.push({ path: "" });
      this.$refs[formName].resetFields();
    },
    open(msg) {
      this.$alert(msg, "提醒", {
        confirmButtonText: "确定",
      });
    },
    //通过手机获取验证码
    getCode() {
      if (this.smsSending) return false;
      this.smsSending = true;
      this.codemsg = "60s获取验证码";
      let i = 59;
      var timer = setInterval(() => {
        this.codemsg = i-- + "s获取验证码";
        if (i <= 0) {
          clearInterval(timer);
          this.codemsg = "获取验证码";
          this.smsSending = false;
        }
      }, 1000);
      //获取验证码
      this.$http
        .get("/api/VerifyCode?phone=" + this.ruleForm.phone)
        .then((r) => {
          if (r.data.code != 200) {
            clearInterval(timer);
            this.open(r.data.msg);
            this.codemsg = "获取验证码";
            this.smsSending = false;
          }
        }) //接口调用成功返回的数据
        .catch((err) => console.log(err)); //接口调用失败返回的数据
    },
    //通过邮箱获取验证码
    getCodeWithEmail() {
      if (this.smsSending) return false;
      this.smsSending = true;
      this.codemsg = "60s获取验证码";
      let i = 59;
      var timer = setInterval(() => {
        this.codemsg = i-- + "s获取验证码";
        if (i <= 0) {
          clearInterval(timer);
          this.codemsg = "获取验证码";
          this.smsSending = false;
        }
      }, 1000);
      //获取验证码
      this.$http
        .get("/api/email?email=" + this.ruleForm.email)
        .then((r) => {
          if (r.data.code != 200) {
            clearInterval(timer);
            this.open(r.data.msg);
            this.codemsg = "获取验证码";
            this.smsSending = false;
          }
        }) //接口调用成功返回的数据
        .catch((err) => console.log(err)); //接口调用失败返回的数据
    },
  },
};
</script>